<ng-template [ngIf]="conf">
  <div
    class="holder {{ conf.key }} {{
      isPeynirciSerdivan ? 'peynirci-serdivan' : ''
    }}"
  >
    <div class="inner-holder">
      <div class="logo-holder">
        <img [src]="logoSrc" [alt]="conf.key" />
      </div>

      <div class="lp-top-left">
        <img [src]="lpTopLeftSrc" />
      </div>
      <div class="lp-top-right">
        <img src="/assets/lp/{{ conf.key }}/top-right-thanks.png" />
      </div>

      <ng-template [ngIf]="navState?.landingPageKey">
        <div class="text-holder" *ngIf="navState.landingPageKey === 'eker'">
          <b
            >Tebrikler, Eker Online Market'ten
            <a href="market.eker.com" target="_blank">(market.eker.com)</a> 500
            TL ve üzeri alışverişlerde geçerli %5 ek indirim kazandınız. </b
          ><br />
          <b>İşte indirim kodunuz: BILGE5 </b><br />
          Kampanyadan yararlanmak için Ödeme Bilgilerim sayfasında "İndirim
          kuponu" alanına BILGE5 yazmanız yeterlidir. Haydi alışverişe başlayın.
        </div>

        <div class="text-holder" *ngIf="navState.landingPageKey === 'sportive'">
          <b
            >Tebrikler. Sportive'den 3500 TL ve üzeri alışverişlerde geçerli 200
            TL ek indirim kazandınız. </b
          ><br />
          <b>İşte indirim kodunuz: {{ navState.discountCode }} </b><br />
          İndirim kodunuzu
          <a href="https://www.sportive.com.tr" target="_blank">
            www.sportive.com.tr
          </a>
          ve Sportive Mobil Uygulamasında kullanabilirsiniz. İndirim kodunuzu
          sepeti onaylamadan "İndirim Kodu" yazan alana girebilirsiniz. Haydi
          alışverişe başlayın.
        </div>

        <div class="text-holder" *ngIf="navState.landingPageKey === 'scooter'">
          <b>
            Tebrikler, Scooter Ayakkabı web sitesinden (
            <a
              href="http://www.scooter.com.tr"
              target="_blank"
              rel="noreferrer"
            >
              www.scooter.com.tr
            </a>
            ) ilave %10 indirim kazandınız.
          </b>
          <br />
          <b>İşte indirim kodunuz: SCOOTER10 </b><br />
          Kampanyadan yararlanmak için indirim kodunuzu, alışverişi tamamlamadan
          "Hediye Çeki" alanına yazmanız yeterlidir. Haydi aşağıdaki bağlantıya
          tıklayarak indirimli alışverişe başlayın.
        </div>
      </ng-template>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'elbisebul'">
        <b>
          Tebrikler, Elbisebul web sitesinden (
          <a href="https://www.elbisebul.com" target="_blank">
            www.elbisebul.com
          </a>
          ) %10 ilave indirim kazandınız.
        </b>
        <br />
        <b>İşte indirim kodunuz: B10 </b><br />
        Kampanyadan yararlanmak için indirim kodunuzu, sepet sayfasında,
        "İndirim Kodu" yazan alana girebilirsiniz. Haydi aşağıdaki bağlantıya
        tıklayarak indirimli alışverişe başlayın.
      </div>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'yasomi'">
        <b>
          Tebrikler, Yasomi web sitesinden (
          <a href="https://www.yasomi.com.tr" target="_blank">
            www.yasomi.com.tr
          </a>
          ) %3 ilave indirim kazandınız.
        </b>
        <br />
        <b>İşte indirim kodunuz: YSM3 </b><br />
        Kampanyadan yararlanmak için, üye olarak indirim kodunuzu ilgili alana
        yazabilirsiniz. İndirim
        <span
          (click)="productLinksModalShowing = true"
          class="product-links-modal-button"
        >
          seçili ürünlerde</span
        >
        31.12.2024'e kadar geçerlidir. Haydi aşağıdaki bağlantıya tıklayarak
        indirimli alışverişe başlayın.
      </div>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'boost'">
        <b>
          Tebrikler, anketiniz başarıyla tamamlandı ve Boost Oxygen’den
          <a href="https://www.boostoxygen.com.tr" target="_blank">
            www.boostoxygen.com.tr
          </a>
          %15 ilave indirim kazandınız.
        </b>
        <br />
        <b>İşte indirim kodunuz: Oxygen4u </b><br />
        Kampanyadan faydalanmak için, üye olduktan sonra "Kupon kullan" bölümünü
        seçerek kodunuzu girmeniz yeterlidir. İndirim Haydi aşağıdaki bağlantıya
        tıklayarak indirimli alışverişe başlayın.
      </div>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'muhiku'">
        <b>
          Tebrikler, anketiniz başarıyla tamamlandı ve Muhiku web sitesinden (
          <a href="https://muhiku.com" target="_blank">muhiku.com</a>
          ) %10 ek indirim kazandınız.
        </b>
        <br />
        <b>İşte indirim kodunuz: bilgesin10</b><br />
        Kampanyadan faydalanmak için, «Kupon» bölümüne kodunuzu girmeniz
        yeterlidir. Haydi alışverişe başlayın.
      </div>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'mydukkan'">
        <b>
          Tebrikler, anketiniz başarıyla tamamlandı ve Mydukkan web sitesinden (
          <a href="https://mydukkan.co" target="_blank">mydukkan.co</a>
          ) %10 ek indirim kazandınız.
        </b>
        <br />
        <b>İşte indirim kodunuz: bilgesin10</b><br />
        Kampanyadan faydalanmak için, «Kupon» bölümüne kodunuzu girmeniz
        yeterlidir. Haydi alışverişe başlayın.
      </div>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'itsbasic'">
        <b>
          Tebrikler, anketiniz başarıyla tamamlandı ve
          <a href="https://www.itsbasic.com" target="_blank">www.itsbasic.com</a
          >'dan 200 TL ek indirim kazandınız.
        </b>
        <br />
        <b>İşte indirim kodunuz: bilgesin200</b><br />
        Kampanyadan faydalanmak için, «Kupon» bölümüne kodunuzu girmeniz
        yeterlidir. Haydi alışverişe başlayın.
      </div>

      <div
        class="text-holder"
        *ngIf="
          navState.landingPageKey === 'hummel' ||
          navState.landingPageKey === 'hummel-2'
        "
      >
        <b>
          Tebrikler, anketiniz başarıyla tamamlandı ve Hummel web sitesinden
          <a href="https://www.hummel.com.tr" target="_blank"
            >www.hummel.com.tr</a
          >
          %10 ek indirim kazandınız.
        </b>
        <br />
        <b>İşte indirim kodunuz: {{ navState.discountCode }} </b><br />
        Kampanyadan faydalanmak için, üye olarak giriş yapmanız gerekmektedir.
        Sepet sayfasında «Kupon Kodu Kullan» alanına kodunuzu girmeniz
        yeterlidir. Haydi alışverişe başlayın.
      </div>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'kolektif'">
        <b>
          Tebrikler, Kolektif House’dan bir gün ücretsiz giriş hakkı kazandınız.
        </b>
        <br />
        <b>(tüm şubelerde geçerlidir)</b>
        <br />
        <b
          >İşte indirim kodunuz:
          {{ navState.discountCode || "BILGESIN500" }} </b
        ><br />
        Kampanyadan yararlanmak için, şubeye gitmeden önce <a
          href="https://koplanet.kolektifhouse.co/login"
          target="_blank"
          >kolektifhouse.co</a
        >’dan üye girişi yaparak, Gezgin Üyelik kapsamında Günlük Giriş
        seçeneğini seçmeniz ve indirim kodunu hesabınıza tanımlamanız
        yeterlidir.
      </div>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'lucid'">
        <b>
          Tebrikler, anketiniz başarıyla tamamlandı ve
          <a href="https://lucidbiyokimya.com" target="_blank"
            >lucidbiyokimya.com</a
          >’dan seçili ürünlerde 100 TL ek indirim kazandınız.
        </b>
        <br />
        <span
          (click)="productLinksModalShowing = true"
          class="product-links-modal-button"
        >
          Seçili ürünleri görmek için tıklayınız.
        </span>
        <br />
        <b>İşte indirim kodunuz: BetterTogether10 </b>
        <br />
        İndirim kodunuzu sepetim sayfasında "Coupon code" alanına yazmanız
        yeterlidir.
      </div>

      <div class="text-holder" *ngIf="isPeynirci && !isPeynirciSerdivan">
        <div *ngIf="!smsNavState">
          <b>
            Tebrikler, anketiniz başarıyla tamamlandı ve Peynirci Baba Zonguldak
            Ereğli mağazamızdan 1 adet hediye ürün kazandınız.
          </b>
          <br />
          <p>
            Hediye ürün Seçenekleri: Peynirci Baba Taze Kaşar Peyniri (400 gr)
            ya da Akçaabat Tereyağı (400 gr)
          </p>
          <br />
          <p>
            Size aşağıdaki özel karekodunu Ereğli mağazamızdaki ekip
            arkadaşlarımıza okutarak, teslim alabilirsiniz.
          </p>
        </div>
        <div class="info-holder">
          <div class="info-qr-holder">
            <b *ngIf="smsNavState">Hediyenizi almak için:</b>
            <img [src]="qrImage" style="border-radius: 10px" *ngIf="qrImage" />
          </div>
          <div class="info-map-holder-wrapper">
            <b *ngIf="smsNavState">Mağazaya ulaşmak için:</b>
            <div class="info-map-holder">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2998.581905217755!2d31.432347777434668!3d41.27443837131439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x409c5b2eaa7e3105%3A0x3c119399c270b6c1!2sPeynirci%20Baba%20Zonguldak%20Ere%C4%9Fli!5e0!3m2!1sen!2str!4v1748430874957!5m2!1sen!2str"
                width="100%"
                height="150"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div class="info-map-holder-content">
                <a
                  href="https://maps.app.goo.gl/prKem4yXeDKW8ZnLA"
                  target="_blank"
                  >Peynirci Baba Zonguldak Ereğli</a
                >
                <p>Bağlık, Erdemir Cd. no:233/D, 67300 Ereğli/Zonguldak</p>
                <a href="tel:+902626439070" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    style="vertical-align: middle; margin-right: 5px"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    ></path>
                  </svg>
                  (0262) 643 90 70
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-holder" *ngIf="isMed">
        <div *ngIf="!smsNavState">
          <b>
            Tebrikler! Gölbaşı Med Kurs Merkezi’nden İlgi, Yetenek ve Kişilik
            Eğilimleri Analizi’ni (liste fiyatı:1399 TL) ücretsiz kazandınız.
          </b>
          <br /><br />
          <p>
            Size özel karekodu kurs merkezimizdeki yetkililerimize okutarak
            öğrencinizi teste dahil edebilirsiniz. (30.04.2026’ya kadar
            geçerlidir.)
          </p>
          <br />
          <p>
            Kurs merkezimize gelmeden önce randevu almak veya diğer konularla
            ilgili sorularınız için 0555 064 6286 numaralı telefondan bizimle
            iletişime geçebilirsiniz.
          </p>
        </div>
        <div class="info-holder">
          <div class="info-qr-holder">
            <b *ngIf="smsNavState"
              >Kazandığınız ücretsiz test sürecini başlatmak için karekodu kurum
              yetkilisine okutunuz.</b
            >
            <img [src]="qrImage" style="border-radius: 10px" *ngIf="qrImage" />
          </div>
          <div class="info-map-holder-wrapper">
            <b *ngIf="smsNavState">Kurs Merkezine ulaşmak için:</b>
            <div class="info-map-holder">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3065.2595521056437!2d32.80759911264998!3d39.80116939275421!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d343d8eaf3f237%3A0x61ee926d3f95a346!2zTUVEIEXEn2l0aW0gS3VydW1sYXLEsSBHw7ZsYmHFn8SxIEt1cnMgTWVya2V6aQ!5e0!3m2!1str!2str!4v1770036711109!5m2!1str!2str"
                width="100%"
                height="150"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div class="info-map-holder-content">
                <a
                  href="https://maps.app.goo.gl/sd6fqvJVF7yYJ4ms8"
                  target="_blank"
                  >MED Eğitim Kurumları Gölbaşı Kurs Merkezi</a
                >
                <p>Şafak, Tek Yolu Caddesi 11/9, 06830 Gölbaşı/Ankara</p>
                <a href="tel:+905550646286" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    style="vertical-align: middle; margin-right: 5px"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    ></path>
                  </svg>
                  (0555) 064 62 86
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-holder" *ngIf="isNesPilates">
        <div *ngIf="!smsNavState">
          <b>
            Tebrikler! Nes Pilates’ten ücretsiz Cosfer marka 3’lü direnç
            lastiği kazandınız.
          </b>
          <br /><br />
          <p>
            Size özel karekodu pilates stüdyomuzdaki yetkilimize okutarak
            hediyenizi teslim alabilirsiniz. (30.11.2026’ya kadar geçerlidir.)
          </p>
          <br />
          <p>İletişim: 0533 379 25 09</p>
        </div>
        <div class="info-holder">
          <div class="info-qr-holder">
            <b *ngIf="smsNavState"
              >3’lü direnç lastiği hediyenizi almak için karekodu stüdyo
              yetkilisine okutunuz.</b
            >
            <img [src]="qrImage" style="border-radius: 10px" *ngIf="qrImage" />
          </div>
          <div class="info-map-holder-wrapper">
            <b *ngIf="smsNavState">Stüdyomuza ulaşmak için:</b>
            <div class="info-map-holder">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.0!2d29.0905764!3d41.0939204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cacbb111c2a71d%3A0x4ddda31890912f48!2sNes%20Pilates!5e0!3m2!1str!2str!4v1791270000000!5m2!1str!2str"
                width="100%"
                height="150"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div class="info-map-holder-content">
                <a
                  href="https://maps.app.goo.gl/4qmUnsGk6BWVrN4M9"
                  target="_blank"
                  >Nes Pilates</a
                >
                <p>
                  Kavacık Mah. FSM Cad. Akbey Sok. Kardeşler İş Hanı, No:10/5-6,
                  34810 Beykoz/İstanbul
                </p>
                <a href="tel:+905333792509" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    style="vertical-align: middle; margin-right: 5px"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    ></path>
                  </svg>
                  (0533) 379 25 09
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-holder" *ngIf="navState.landingPageKey === 'teqsma'">
        <b>
          Tebrikler,
          <a href="https://www.teqsma.com" target="_blank">www.teqsma.com</a>'dan
          %25 ek indirim kazandınız.
        </b>
        <br />
        <b>(Bütün kampanyalara ilavedir ve tüm ürünlerde geçerlidir)</b>
        <br />
        <b>İşte indirim kodunuz: {{ navState.discountCode }} </b><br />
        Kampanyadan yararlanmak için indirim kodunuzu, ödeme sayfasındaki
        "İndirim Kodu" alanına yazmanız yeterlidir. Haydi aşağıdaki bağlantıya
        tıklayarak indirimli alışverişe başlayın.
      </div>

      <div class="text-holder" *ngIf="isPeynirci && isPeynirciSerdivan">
        <div *ngIf="!smsNavState">
          <b>
            Tebrikler anketiniz başarıyla tamamlandı ve Peynirci Baba Sakarya
            Serdivan (Merkez, Serdivan Yazlık, Yazlık, Süleyman Binek Cad. Bina
            No: 137 A, 54130 Serdivan/Sakarya, 0850 305 3202) mağazamızdan 1
            adet Akçaabat Tereyağı (400 gr) kazandınız.
          </b>
          <br />
          <p>
            Size özel aşağıdaki karekodu Serdivan mağazamızdaki ekip
            arkadaşlarımıza okutarak teslim alabilirsiniz. (Kampanya
            31.08.2025'e kadar geçerlidir)
          </p>
          <br />
          <p>
            İndirimler, özel kampanyalar ve sadece takipçilere özel hediyeler
            için bizi WhatsApp kanalımızdan takip edin:
            <a
              href="https://whatsapp.com/channel/0029Vag1fZX8F2pKYrh7952a"
              target="_blank"
              ><b>whatsapp.com/channel/0029Vag1fZX8F2pKYrh7952a</b></a
            >
          </p>
        </div>
        <div class="info-holder">
          <div class="info-qr-holder">
            <b *ngIf="smsNavState">Hediyenizi almak için:</b>
            <img [src]="qrImage" style="border-radius: 10px" *ngIf="qrImage" />
          </div>
          <div class="info-map-holder-wrapper">
            <b *ngIf="smsNavState">Mağazaya ulaşmak için:</b>
            <div class="info-map-holder">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1570.6300395360756!2d30.35776468840786!3d40.79723540644249!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x409df9815e7d4881%3A0xbbb9ade33f9a0443!2sPeynirci%20Baba%20Serdivan!5e0!3m2!1sen!2str!4v1753879092487!5m2!1sen!2str"
                width="100%"
                height="150"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div class="info-map-holder-content">
                <a
                  href="https://maps.app.goo.gl/prKem4yXeDKW8ZnLA"
                  target="_blank"
                  >Peynirci Baba Serdivan</a
                >
                <p>
                  Merkez, Serdivan Yazlık, Yazlık, Süleyman Binek Cad. Bina No:
                  137 A, 54130 Serdivan/Sakarya
                </p>
                <a href="tel:+908503053202" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    style="vertical-align: middle; margin-right: 5px"
                  >
                    <path
                      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    ></path>
                  </svg>
                  (0850) 305 32 02
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!navState?.landingPageKey" style="text-align: center">
        <b>Bu ekranı görüntülemek için lütfen anketi doldurunuz.</b>
      </div>

      <div class="close-dialog" *ngIf="showLinkButton">
        <app-button
          type="link opposite {{ conf.key }}"
          [text]="linkButtonText"
          (click)="goLink()"
        >
        </app-button>
        <ng-template [ngIf]="isPeynirciSerdivan && smsNavState">
          <br />
          <p>
            İndirimler, özel kampanyalar ve sadece takipçilere özel hediyeler<br />
            için bizi WhatsApp kanalımızdan takip edin:
            <br />
            <a
              href="https://whatsapp.com/channel/0029Vag1fZX8F2pKYrh7952a"
              target="_blank"
              ><b>whatsapp.com/channel/0029Vag1fZX8F2pKYrh7952a</b></a
            >
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<app-product-links-modal
  [(visible)]="productLinksModalShowing"
  [landingPageKey]="conf?.key"
></app-product-links-modal>
